/* ===========================================================================
   Const
   =========================================================================== */

export const $body       = document.body;
export const $header     = document.getElementById('js-header');
export const $content    = document.getElementById('js-content');
export const $aside      = document.getElementById('js-aside');

export const hideClass     = 'is-hidden';
export const visibleClass  = 'is-visible';
export const activeClass   = 'is-active';
export const openClass     = 'is-open';
export const movedClass    = 'is-moved';
export const srollingClass = 'is-scrolling';
export const loadingClass  = 'is-loading';
export const dropClass     = 'is-droping';
export const animateClass  = 'is-animate';

export const headers = new Headers({
  'X-Requested-With': 'XMLHttpRequest'
});

const credentials =  'include';

export const fetchParam = {
  headers,
  credentials
};
